export class UserInfo {
  public name?: string;
  public email?: string;
  public nickname?: string;
  public picture?: string;
  public phoneNumber?: string;
  public role?: string;
  public roles?: string;
  public account_id: string;
  public supplier_id: string;
  public user_id: string;
  public distributor_id: string;
  public reference: string;
  public titles: string;
  public country: string;
  public accountInfo?: any;

  constructor() {
    this.titles = "Clinician";
    this.accountInfo = {};
  }
}
